export const maintenanceInputs = [
    // {
    //     type: 'seizeDate',
    //     InputType: 'Date',

    // },
    {
        type: 'date_entrance_extra_maint',
        InputType: 'Date',
    },
    {
        type: 'date_exit_extra_maint',
        InputType: 'Date',
    },
    {
        type: 'departement_extra_maint',
        InputType: 'text',
    },
    {
        type: 'sector_extra_maint',
        InputType: 'text',
    },
    {
        type: 'garage_name_extra_maint',
        InputType: 'text',
    },

    {
        type: 'technician_name_extra_maint',
        InputType: 'text',
    },
    {
        type: 'odometer',
        InputType: 'number',
    },
    {
        type: 'horometer',
        InputType: 'number',
    },
    {
        type: 'veh_type_extra_maint',
        InputType: 'Select',
        values: ['', 'Light', 'Rail-route'],
    },
    {
        type: 'cost_extra_maint',
        InputType: 'number',
    },
    {
        type: 'invoice_number_extra_maint',
        InputType: 'text',
    },
    {
        type: 'repair_type_extra_maint',
        InputType: 'Select',
        values: [
            '',
            'Abuses',
            'Prevent',
            'Motor',
            'Towing',
            'Telemetry',
            'Tires',
            'Repare',
            'SystemHydroAux',
            'SystemeRailRoute',
            'Transmission'
        ],
    },
    {
        type: 'comment_extra_maint',
        InputType: 'textArea',
    },
    {
        type: 'image',
        InputType: 'image',
    },
];
